import React from "react";
import ImageGallery from "react-image-gallery";
import RoomConfigServices from "./room_config_services";

const RoomConfig = ({
  roomConfig,
  number,
  register,
  isExtra,
  visibleRadio,
  htmlFor,
}) => {
  const refName = isExtra
    ? `extra_room_configs.${number}.id`
    : `room_configs.${number}.id`;

  const images = roomConfig.room_pictures.map((picture) => {
    return {
      original: picture[2].url,
      // thumbnail: picture.slice(-1)[0].url,
    };
  });

  const [isFullscreen, setIsFullscreen] = React.useState(false);

  return (
    <React.Fragment key={roomConfig.id}>
      {register && visibleRadio && (
        <div className="hidden">
          <input
            className="accomodation_checkbox"
            id={`${refName}.${roomConfig.id}`}
            type="radio"
            value={roomConfig.id}
            defaultChecked={roomConfig.selected}
            {...register(refName)}
          />
        </div>
      )}
      <label
        className={`row align-items-center room-label ${
          roomConfig.selected ? "room-label-selected" : ""
        }`}
        htmlFor={htmlFor || `${refName}.${roomConfig.id}`}
      >
        {images.length > 0 ? (
          <div
            className={`col-lg-4 col-md-12 ${
              !isFullscreen && "room-image-gallery-non-fullscreen"
            }`}
          >
            <ImageGallery
              items={images}
              showThumbnaills={false}
              showPlayButton={false}
              onScreenChange={(e) => setIsFullscreen(e)}
            />
          </div>
        ) : (
          <div></div>
        )}
        <div
          className={`${
            images.length > 0 ? "col-lg-6" : "col-lg-10"
          } col-md-12 d-flex flex-column`}
        >
          <div
            className="room-name"
            htmlFor={htmlFor || `${refName}.${roomConfig.id}`}
          >
            {roomConfig.room_type}
          </div>
          <div className="room-notes">
            {roomConfig.room_notes
              // ?.sort((a, b) => a.position > b.position)
              ?.map((roomNoteType) => {
                return (
                  <div key={roomNoteType.name}>
                    <strong>{roomNoteType.name}: </strong>
                    {roomNoteType.room_notes.join(" | ")}
                  </div>
                );
              })}
          </div>
        </div>
        <div className="col-lg-2 col-md-12 px-0 py-1">
          <div className="row">
            <div
              className="col-lg-12 col room-icon text-nowrap d-flex justify-content-center align-items-center"
              dangerouslySetInnerHTML={{
                __html: roomConfig.passenger_icons,
              }}
            />
            <span className="col-lg-12 col form-check-label room_config_label_price">
              <em
                className="room-label-price w-100"
                dangerouslySetInnerHTML={{ __html: roomConfig.price_label }}
              />
            </span>
            {!roomConfig.selected && (
              <div className="col-12 d-flex justify-content-center align-items-center py-1">
                <div className="btn btn-primary">Zvolit</div>
              </div>
            )}
          </div>
        </div>
      </label>
      {roomConfig.selected && roomConfig.services?.length > 0 && (
        <RoomConfigServices
          services={roomConfig.services}
          number={number}
          register={register}
          isExtra={isExtra}
        />
      )}
      <div className="clearfix" />
    </React.Fragment>
  );
};

export default RoomConfig;
